/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkAlcoGlassBeerIcon16Light } from './FoodDrinkAlcoGlassBeerIcon16Light';
import { FoodDrinkAlcoGlassBeerIcon16Regular } from './FoodDrinkAlcoGlassBeerIcon16Regular';
import { FoodDrinkAlcoGlassBeerIcon16Solid } from './FoodDrinkAlcoGlassBeerIcon16Solid';
import { FoodDrinkAlcoGlassBeerIcon20Light } from './FoodDrinkAlcoGlassBeerIcon20Light';
import { FoodDrinkAlcoGlassBeerIcon20Regular } from './FoodDrinkAlcoGlassBeerIcon20Regular';
import { FoodDrinkAlcoGlassBeerIcon20Solid } from './FoodDrinkAlcoGlassBeerIcon20Solid';
import { FoodDrinkAlcoGlassBeerIcon24Regular } from './FoodDrinkAlcoGlassBeerIcon24Regular';
import { FoodDrinkAlcoGlassBeerIcon24Solid } from './FoodDrinkAlcoGlassBeerIcon24Solid';
import { FoodDrinkAlcoGlassBeerIcon32Regular } from './FoodDrinkAlcoGlassBeerIcon32Regular';
import { FoodDrinkAlcoGlassBeerIcon64Regular } from './FoodDrinkAlcoGlassBeerIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkAlcoGlassBeerIcon16Light,
        regular: FoodDrinkAlcoGlassBeerIcon16Regular,
        solid: FoodDrinkAlcoGlassBeerIcon16Solid,
    },
    20: {
        light: FoodDrinkAlcoGlassBeerIcon20Light,
        regular: FoodDrinkAlcoGlassBeerIcon20Regular,
        solid: FoodDrinkAlcoGlassBeerIcon20Solid,
    },
    24: {
        regular: FoodDrinkAlcoGlassBeerIcon24Regular,
        solid: FoodDrinkAlcoGlassBeerIcon24Solid,
    },
    32: {
        regular: FoodDrinkAlcoGlassBeerIcon32Regular,
    },
    64: {
        regular: FoodDrinkAlcoGlassBeerIcon64Regular,
    },
};
export var FoodDrinkAlcoGlassBeerIcon = forwardRef('FoodDrinkAlcoGlassBeerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
